export const formatZAR = (amount) =>
  typeof amount === 'number'
    ? new Intl.NumberFormat('en-ZA', {
        style: 'currency',
        currency: 'ZAR',
        minimumFractionDigits: 2,
      }).format(amount)
    : amount

export const stripHtml = (str) => {
  if (typeof str !== 'string') return ''
  return str.replace(/<[^>]*>/g, '').replace(/[<>]/g, '').trim()
}

const BOX_IDS = new Set([
  'Vendetta_Booster_Box',
  'Spiritforged_Booster_Box',
  'Origins_Booster_Box',
  'Unleashed_Booster_Box',
])

const PACK_IDS = new Set([
  'Vendetta_Booster_Pack',
  'Spiritforged_Booster_Pack',
  'Origins_Booster_Pack',
  'Unleashed_Booster_Pack',
])

const ALL_LIMITED_IDS = new Set([...BOX_IDS, ...PACK_IDS])

export const isRiftboundLimited = (id) => ALL_LIMITED_IDS.has(id)

export const getRiftboundLimit = (id) => {
  if (BOX_IDS.has(id)) return { max: 1, unit: 'booster box', per: 'customer' }
  if (PACK_IDS.has(id)) return { max: 6, unit: 'booster packs', per: 'customer' }
  return null
}

export const getRiftboundLimitMessage = (id) => {
  const limit = getRiftboundLimit(id)
  if (!limit) return null
  return `Limit ${limit.max} ${limit.unit} per ${limit.per}`
}

export const checkRiftboundLimit = (id, currentQty, desiredAddQty) => {
  const limit = getRiftboundLimit(id)
  if (!limit) return null
  if (currentQty + desiredAddQty > limit.max) {
    return `You can only purchase ${limit.max} ${limit.unit} per ${limit.per}. You already have ${currentQty} in your cart.`
  }
  return null
}
